import { registerQuillPlainClipboard } from '@interacta-shared/util-common';
import Quill from 'quill';
import { TableUp, updateTableConstants } from 'quill-table-up';

let registered = false;

const COL_MIN_WIDTH_PX = 120;

/**
 * Four constraints hold this together:
 *
 * - It must be an explicit call, not a bare side-effect import: this lib
 *   declares `sideEffects: false`, so a module imported only for its side
 *   effect is dropped by the bundler and the blots silently never register.
 * - `TableUp.register()` re-wraps the block formats already registered, so it
 *   must run after the app's own block blots (divider, inline image). An
 *   environment initializer is late enough: those register from side-effect
 *   imports evaluated at module load.
 * - `TableUp.register()` takes the `modules/clipboard` slot for its own
 *   TableClipboard, which is why `registerQuillPlainClipboard()` runs after
 *   it: it subclasses whatever it finds, landing back on top without losing
 *   the table matchers underneath.
 * - The column floor is a package-level constant, not a module option, so it
 *   cannot come from the per-editor config in `buildTableUpModule()`. Its
 *   setter also copies blot names onto the format statics, so it has to run
 *   before `TableUp.register()` reads them. Without it the floor stays at the
 *   vendor's 40px, which a table only reaches past fifteen columns — by then
 *   fixed-width layout has divided the editor exactly as full width would,
 *   and the horizontal scroll it exists to trigger never happens.
 */
export function registerQuillTableUp(): void {
    if (registered) return;
    registered = true;

    updateTableConstants({
        tableUpSize: { colMinWidthPx: COL_MIN_WIDTH_PX },
    });
    TableUp.register();
    Quill.register({ 'modules/table-up': TableUp }, true);
    registerQuillPlainClipboard();
}
